module.exports = __webpack_public_path__ + "static/media/Visa.351f14e3.svg";